module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Detectors.2478ba3e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Detectors.svg
// module id = 3549
// module chunks = 0